import { FC, useEffect, useRef, useState } from "react";
import {
  useAlertStore,
  useGeneralStore,
  useThemeStore,
  useUserStore,
} from "../../../stores";
import { Row } from "../../../components/containers";
import { SelectorInput, TextInput } from "../../../components/inputs";
import { Cheque, Customer } from "../../../types";
import { ChequeSelector } from "../../../components/cheque";
import { ChequeApi, FactorApi } from "../../../api";
import { ChequeSelectorRef } from "../../../components/cheque/cheque-selector/types";
import { addComma } from "../../../utils";
import { JustifyContent } from "../../../components/containers/types";
import { Button } from "../../../components/buttons";
import useSpendFactorStore from "./store";

const SpendFactor: FC = () => {
  const theme = useThemeStore((s) => s.theme);
  const customers = useGeneralStore((s) => s.customers);
  const pushAlert = useAlertStore((s) => s.pushAlert);
  const hasUserAccess = useUserStore((s) => s.hasUserAccess);

  const selectorRef = useRef<ChequeSelectorRef>(null);

  const [customer, setCustomer] = useState<Customer | null>(null);
  const [desc, setDesc] = useState<string>("");
  const [totalPrice, setTotalPrice] = useState<string>("");

  const selectedCheques = useSpendFactorStore((s) => s.selectedCheques);
  const setSelectedCheques = useSpendFactorStore((s) => s.setSelectedCheques);

  const [loading, setLoading] = useState<boolean>(false);

  const onSearchCheque = (searchValue: string): Promise<Array<Cheque>> => {
    return ChequeApi.search({
      number: searchValue.toLowerCase(),
      account_no: "",
      bank: null,
      confirmedWith: "",
      fromDate: 0,
      name: "",
      price: 0,
      shenase: "",
      status: { status: "delivered", fa: "" },
      toDate: 0,
    });
  };

  useEffect(() => {
    let tp = 0;
    selectedCheques.forEach((c) => {
      tp += c.cheque.price;
    });
    if (tp) setTotalPrice(addComma(tp));
    else setTotalPrice("");
  }, [selectedCheques]);

  const onSubmit = (): void => {
    if (!hasUserAccess(["SpendCheque"]))
      return pushAlert("دسترسی غیر مجاز", "error");

    if (!customer || !desc || !selectedCheques.length)
      return pushAlert(
        "لطفا مطمئن شوید که فیلدها به درستی پر شده اند",
        "error"
      );

    setLoading(true);
    FactorApi.spend(customer._id.$oid, desc, selectedCheques)
      .then(() => {
        selectorRef.current?.clear();
        setCustomer(null);
        setDesc("");
        pushAlert("عملیات موفقیت آمیز");
      })
      .catch((err) => {
        pushAlert(err.msg || "unknown error", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    const idx = window.location.href.indexOf("?number=");
    if (idx < 0) return;
    const number = window.location.href.substring(idx + 8);
    selectorRef.current?.setSearchValue(decodeURI(number));
  }, []);

  return (
    <div
      style={{
        background: theme.overlay,
        borderRadius: 15,
        minHeight: 200,
        marginTop: "1rem",
        padding: "1rem",
      }}
    >
      <Row
        style={{ width: "100%", marginBottom: "2rem" }}
        gap={20}
        className="factor-activity-row"
      >
        <SelectorInput<Customer>
          items={customers}
          uniqueKey={"fullname"}
          selected={customer}
          setSelected={setCustomer}
          stringField={"fullname"}
          renderStrings={["fullname", "phone"]}
          compareFn={(c, v) =>
            c.fullname.toLowerCase().includes(v.toLowerCase()) ||
            c.phone.includes(v)
          }
          label="نام مشتری"
        />

        <TextInput label="بابت" value={desc} setValue={setDesc} />

        <TextInput
          value={totalPrice}
          setValue={setTotalPrice}
          label="کل مبلغ (ریال)"
          inputProps={{
            readOnly: true,
            placeholder: "به طور خودکار پر می شود",
          }}
        />
      </Row>

      <Row
        style={{ width: "100%", marginBottom: "2rem" }}
        gap={20}
        className="factor-activity-row"
      >
        <ChequeSelector
          items={onSearchCheque}
          label="انتخاب چک"
          selectedItems={selectedCheques}
          setSelectedItems={setSelectedCheques}
          ref={selectorRef}
        />
      </Row>

      <Row style={{ width: "100%" }} justifyContent={JustifyContent.End}>
        <Button
          onClick={onSubmit}
          loading={loading}
          background={theme.primary}
          color={theme.textOnprimary}
        >
          ثبت
        </Button>
      </Row>
    </div>
  );
};

export default SpendFactor;
